import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {AbstractFilter} from './AbstractFilter';

export class WinFilter extends AbstractFilter {
    constructor(public name: string) {
        super(name);
    }

    public filter(response: Message, session: Session): boolean {
        return this.getWin(response) > 0;
    }

    protected getWin(response: Message): number {
        let win = 0;

        for (const pay of this.getSpin(response).pays) {
            win += pay.win;
        }

        return win;
    }
}
